import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const YOUTUBEPLAYERBLOCK_LEGACY_FIELD_ORDER = [
  "video_id"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  youtubePlayerBlockDescriptor: _generatedYoutubePlayerBlockDescriptor,
  youtubePlayerBlockBlocDefinition,
  youtubePlayerBlockDashboardLayout,
  youtubePlayerBlockConfig,
  youtubePlayerBlockResolveConfig,
  youtubePlayerBlockProperties,
} = doodBlockConfig(
  {
    name: "Video - Youtube player",
    componentType: 'YoutubePlayerBlockComponent',
    category: 'media',
    description: "Video - Youtube player.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    video_id: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.youtube-player.video-id.label",
        help: "pages.blocks.youtube-player.video-id.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.youtube-player.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.youtube-player.fieldset.video.label",
            fields: ["video_id"],
          },
        ],
      },
    ],
  })
);

export function youtubePlayerBlockDescriptor(): IBlockDescriptor;
export function youtubePlayerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function youtubePlayerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedYoutubePlayerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedYoutubePlayerBlockDescriptor, youtubePlayerBlockProperties, fieldOrder);
}

export {
  youtubePlayerBlockBlocDefinition,
  youtubePlayerBlockDashboardLayout,
  youtubePlayerBlockProperties,
  youtubePlayerBlockConfig,
  youtubePlayerBlockResolveConfig,
};

export type YoutubePlayerBlockConfig = typeof youtubePlayerBlockConfig;
